import { Action } from '@ngrx/store';
import { CheckPasswordInterface } from '../../models/check-password.interface';

export enum ECheckPasswordActions {
  UpdateCheckPasswordVisibility = '[CHECK_PASSWORD] Hide/Display check password',
  UpdateCheckPasswordVisibilitySuccess = '[CHECK_PASSWORD] Hide/Display check password success',
}

export class UpdateCheckPasswordVisibility implements Action {
  public readonly type = ECheckPasswordActions.UpdateCheckPasswordVisibility;
  constructor(public payload: CheckPasswordInterface) {}
}

export class UpdateCheckPasswordVisibilitySuccess implements Action {
  public readonly type = ECheckPasswordActions.UpdateCheckPasswordVisibilitySuccess;
  constructor(public payload: CheckPasswordInterface) {}
}

export type CheckPasswordActions = UpdateCheckPasswordVisibility | UpdateCheckPasswordVisibilitySuccess;
